import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  customReports: [],
  allCustomReports: [],
  totalPages: 0,
  totalRecords: 0,
  customReport: null,
  errorStatus: null,
  customReportParameter: [],
};
const getters = {
  getApiLoad_17: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_CustomReports(state, customReports) {
    state.customReports = customReports.items;
    state.totalPages = customReports.totalPages;
    state.totalRecords = customReports?.totalRecords ?? 0;
  },
  SET_AllCustomReports(state, customReports) {
    state.allCustomReports = customReports;
  },
  SET_CustomReport(state, customReport) {
    state.customReport = customReport;
  },
  SET_CustomReportParameter(state, customReport) {
    state.customReportParameter = customReport;
  },
};
const actions = {
  errorCustomReport({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllCustomReports({ commit, dispatch, rootState }) {
    return apiClient
      .get('/CustomReports/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllCustomReports', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCustomReport', error);
      });
  },
  getCustomReportsWithPagination({ commit, dispatch, rootState }, { pageNumber, pageSize, title }) {
    var url = '/CustomReports/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_CustomReports', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCustomReport', error);
      });
  },
  getCustomReportParameter({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/CustomReports/Parameters?customReportId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_CustomReportParameter', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCustomReport', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
